import React, { useState } from "react";
import {
  MDBNavbar,
  MDBContainer,
  MDBIcon,
  MDBNavbarNav,
  MDBNavbarItem,
  MDBNavbarToggler,
  MDBCollapse,
} from "mdb-react-ui-kit";
import { NavLink } from "react-router-dom";

export default function Appbar() {
  const [showNav, setShowNav] = useState(false);

  return (
    <>
      <MDBNavbar expand="lg" light style={{ backgroundColor: "#e3f2fd" }}>
        <MDBContainer fluid>
          <NavLink to="/" className="navbar-brand">
            Isha Narola
          </NavLink>
          <MDBNavbarToggler
            type="button"
            data-target="#navbarColor02"
            aria-controls="navbarColor02"
            aria-expanded="false"
            aria-label="Toggle navigation"
            onClick={() => setShowNav(!showNav)}
          >
            <MDBIcon icon="bars" fas />
          </MDBNavbarToggler>
          <MDBCollapse show={showNav} navbar>
            <MDBNavbarNav className="me-auto mb-2 mb-lg-0">
              <MDBNavbarItem>
                <NavLink to="/about" className="active nav-link">
                  About
                </NavLink>
              </MDBNavbarItem>
              <MDBNavbarItem>
                <NavLink to="/apitasks" className="active nav-link">
                  API Tasks
                </NavLink>
              </MDBNavbarItem>
              <MDBNavbarItem>
                <NavLink to="/form" className="active nav-link">
                  Form
                </NavLink>
              </MDBNavbarItem>
              <MDBNavbarItem>
                <NavLink to="/projects" className="active nav-link">
                  Projects
                </NavLink>
              </MDBNavbarItem>
              <MDBNavbarItem>
                <NavLink to="/practice" className="active nav-link">
                  Practice Work
                </NavLink>
              </MDBNavbarItem>
            </MDBNavbarNav>
          </MDBCollapse>
        </MDBContainer>
      </MDBNavbar>
    </>
  );
}
